import { Features } from '../types/markets/Features';
import { MarketConfig } from '../types/markets/MarketConfig';
import featureMarket from './markets/index';
import { httpClient } from '../utils/http';
import { logger } from '../utils/logger';

/**
 * Get market configuration by locale code "lang_Mark"
 * @param locale Sting  "lang_Mark"
 * @returns MarketConfig
 */
export const getMarketConfigByLocale = (locale: string) => {
  for (const [key, value] of Object.entries(featureMarket)) {
    const { locale: objLocal } = value;

    if (locale === objLocal) {
      return value;
    }
  }

  return featureMarket.de_DE;
};

/**
 * Fetch search profile config from api
 * @param sp string Code Profile
 * @param FSSApi string Api endpoint
 * @returns MarketConfig
 */
export const fecthSearchProfileConfigFromAPI = async (sp: string, FSSApi: string) => {
  try {
    const { data: fallbackConfig } = await httpClient.get(`${FSSApi}/profiles/${sp}`);

    return new MarketConfig(
      `${fallbackConfig.fssLocale.language}_${fallbackConfig.fssLocale.market}`,
      new Features(),
      {
        fssInputCategory: false,
      },
      sp
    );
  } catch (error) {
    throw new Error(`Unable to fetch the search profile ${sp}: ${error}`);
  }
};

/**
 * Get config search profile
 * @param marketSp string Market sp to search for
 * @returns MarketConfig
 */
export const getConfigBySearchProfile = (marketSp: string) => {
  let marketConfig: MarketConfig | undefined;

  logger.log('getConfigBySearchProfile', marketSp);

  for (const [key, value] of Object.entries(featureMarket)) {
    const { sp } = value;

    if (sp === marketSp) {
      marketConfig = value;
      logger.log('config', sp);
    }
  }

  return marketConfig;
};
